import { Pipe, PipeTransform } from '@angular/core';
import { includes } from 'lodash-es';

@Pipe({
    name: 'switchMultiCase',
    standalone: false
})
export class SwitchMultiCasePipe implements PipeTransform {
    transform<T>(cases: T[], switchParam: T) {
        if (includes(cases, switchParam)) {
            return switchParam;
        }
        return !switchParam;
    }
}
